import {
  groupsParamValue,
  removeMilis,
  generateGetShiftsURIWithQueryParams,
} from './util';

const BASE = 'WHOS_ON_DUTY';

export const LOAD = `${BASE}_LOAD`;
export const LOAD_START = `${BASE}_LOAD_START`;
export const LOAD_SUCCESS = `${BASE}_LOAD_SUCCESS`;
export const LOAD_FAIL = `${BASE}_LOAD_FAIL`;

export const LOAD_SHIFT = `${BASE}_LOAD_SHIFT`;
export const LOAD_SHIFT_START = `${BASE}_LOAD_SHIFT_START`;
export const LOAD_SHIFT_SUCCESS = `${BASE}_LOAD_SHIFT_SUCCESS`;
export const LOAD_SHIFT_FAIL = `${BASE}_LOAD_SHIFT_FAIL`;

export const LOAD_MORE = `${BASE}_LOAD_MORE`;
export const LOAD_MORE_START = `${BASE}_LOAD_MORE_START`;
export const LOAD_MORE_SUCCESS = `${BASE}_LOAD_MORE_SUCCESS`;
export const LOAD_MORE_FAIL = `${BASE}_LOAD_MORE_FAIL`;

export const RESET_INSTANCE = `${BASE}_RESET_INSTANCE`;
export const RESET_ALL = `${BASE}_RESET_ALL`; // dispatched from gwt

/**
 * Fetch on-call information based on params
 * @param {object} params
 * @param {moment} params.at - if specified, will ignore from and to
 * @param {number} params.startIndex
 * @param {number} params.stopIndex
 * @param {Group[]} params.groups array of group objects (used to get list of group uuids)
 * @param {moment} params.from
 * @param {moment} params.to
 * @param {string} params.action eg. WHOS_ON_DUTY_LOAD,WHOS_ON_DUTY_LOAD_MORE
 * @param {string} params.instanceId eg. WHOS_ON_CALL_REPORT,WHOS_ON_CALL_MODAL
 * @param {number} params.membersPerShift
 * @param {string} params.shiftIdFilter
 */
export function getShifts({
  at,
  startIndex,
  stopIndex,
  groups,
  from,
  to,
  action,
  instanceId,
  membersPerShift = 3,
  shiftIdFilter,
}) {
  const params = {
    embed: 'shift',
    groups: groupsParamValue(groups),
    membersPerShift,
  };

  if (startIndex != null) {
    params.offset = startIndex;
    if (stopIndex != null) {
      // Ensure at least one item:
      params.limit = Math.max(1, stopIndex - startIndex);
    }
  }

  if (at) {
    params.at = removeMilis(at.toISOString());
  } else if (!from || !to) {
    const atDate = new Date();
    params.at = removeMilis(atDate.toISOString());
  } else {
    params.from = removeMilis(from.toISOString());
    params.to = removeMilis(to.toISOString());
  }

  return {
    type: action,
    instanceId,
    shiftIdFilter,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/on-call',
      params,
      method: 'get',
      customUriWithParamsGenerator: generateGetShiftsURIWithQueryParams,
    },
  };
}

export function resetInstance(instanceId) {
  return {
    type: RESET_INSTANCE,
    instanceId,
  };
}

export function loadMore(parameters) {
  return getShifts({
    ...parameters,
    action: LOAD_MORE,
  });
}

export function load(parameters) {
  return getShifts({
    ...parameters,
    action: LOAD,
  });
}

export function loadShift(parameters) {
  return getShifts({
    ...parameters,
    action: LOAD_SHIFT,
  });
}
